import { defineFrontendModule } from '~/lib/module';

defineFrontendModule({
  name: 'users',
  owner: 'cella',
  scope: ['frontend', 'backend'],
  description: 'UI for managing users at the system level.',
});
